import { Injectable } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { RoomsListCmd } from "@youm-front/room/domain";
import { RoomsPastListActions } from "../actions";
import { RoomsPastListSelectors } from "../selectors";

@Injectable()
export class RoomsPastListFacade {
  isLoading$ = this.store.pipe(select(RoomsPastListSelectors.isLoading));
  rooms$ = this.store.pipe(select(RoomsPastListSelectors.rooms));

  constructor(private readonly store: Store) {}

  roomsPastList() {
    this.store.dispatch(
      RoomsPastListActions.roomsPastList({ roomsListCmd: new RoomsListCmd({}) })
    );
  }
}
